import Page from 'modules/Page';
import * as parentConstants from 'modules/QAQC/QAQCReportPage/constants';
import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import * as constants from './constants';
import { CylinderBreakingTestUpdateParams } from './constants';
import useCylinderBreakingTestQueries, { CylinderBreakingTestQueries } from './useCylinderBreakingTestQueries';

const CylinderBreakingTestPage = lazyWithSuspense(() => import('./CylinderBreakingTestUpdatePage'));

const page: Page<constants.CylinderBreakingTestUpdateParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage<CylinderBreakingTestUpdateParams, CylinderBreakingTestQueries>({
    WrappedPage: CylinderBreakingTestPage,
    titleFn: () => i18n._(constants.TITLE),
    pageDataHook: useCylinderBreakingTestQueries,
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
